import React from 'react'
import Venues from '../../content/Venues'

const Nearby = (props) => {
  return <Venues {...props} title="Events Nearby" />
}

export default Nearby
